<template>
  <li class="d-flex align-items-center">
    <div class="dropdown">
      <button class="btn feedback-dropdown dropdown-toggle p-0 mr-3"
        data-toggle="dropdown"
        type="button"
        id="dropdownMenuButton"
        aria-haspopup="true"
        aria-expanded="false"
        @click.prevent="showDropdown"
      >
        <span class="fal fa-bullhorn mr-2"></span>Feedback
      </button>
      <div class="dropdown-menu dropdown-menu-right p-2 mr-3" aria-labelledby="dropdownMenuButton">
        <textarea rows="5" class="form-control m-0" placeholder="Your feedback" v-model="feedback.text"></textarea>
        <button href="" class="btn btn-sm btn-dark mt-2 float-right" @click.prevent="sendFeedback" :disabled="btnDisabled">{{ btnText }}</button>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'FeedbackButton',
  mounted() {
    window.$('.dropdown-menu').on('click.bs.dropdown', (e) => {
      e.stopPropagation();
      e.preventDefault();
    });
  },
  methods: {
    showDropdown() {
      this.dropdownVisible = true;
    },
    sendFeedback() {
      this.feedback.link = this.$route.path;
      const db = window.firebase.firestore();

      this.btnDisabled = true;
      this.btnText = 'Sending...';
      db.collection('feedback').add(this.feedback).finally(() => {
        this.feedback.text = '';
        this.btnDisabled = false;
        this.btnText = 'Thank you for your feedback!';

        const t0 = setTimeout(() => {
          this.btnText = 'Send feedback';
          clearTimeout(t0);
        }, 1500);
      });
    },
  },
  data() {
    return {
      feedback: {
        text: '',
      },
      btnText: 'Send feedback',
      btnDisabled: false,
    };
  },
};
</script>

<style scoped lang="scss">
// @import "../styles/_vars.scss";
</style>
